import { Observable } from 'rxjs';
import get from 'lodash/get';

import { ROUTER_LOCATION_CHANGED } from '../redux/route';
import { favoritePackagesRequest } from '../redux/packages';

// TODO: UPDATE THIS UPON IMPLEMENTATION
export default function packageFavoritesRoute(
  action$: ActionObs,
  store: Store,
): Obs {
  return action$
    .ofType(ROUTER_LOCATION_CHANGED)
    .filter(
      action =>
        get(action, 'payload.currentRoute.pathname') === '/cards/favorites',
    )
    .switchMap(({ payload: { params, query } }) =>
      Observable.of(favoritePackagesRequest({ query })),
    );
}
